import { render, staticRenderFns } from "./MessageAccount.vue?vue&type=template&id=36ceaa96&scoped=true"
import script from "./MessageAccount.vue?vue&type=script&lang=js"
export * from "./MessageAccount.vue?vue&type=script&lang=js"
import style0 from "./MessageAccount.vue?vue&type=style&index=0&id=36ceaa96&prod&lang=scss&scoped=true"
import style1 from "./MessageAccount.vue?vue&type=style&index=1&id=36ceaa96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ceaa96",
  null
  
)

export default component.exports